import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
interface ResponseAudioFilterOptionsResponse {
  [key: string]: {
    label: string;
    value: string;
  }[];
}

// 嵌套对象类 - 处理每个过滤选项项
class FilterOptionItem {
  @Required("Label cannot be empty")
  @IsString("Label must be a string")
  label: string;

  @Required("Value cannot be empty")
  value: any;
}

// 主数据类
export class ResponseAudioFilterOptionsData {
  [key: string]: FilterOptionItem[];
}

const transformAndValidateAudioFilterOptions = (
  response: ResponseAudioFilterOptionsResponse
): ResponseAudioFilterOptionsData => {
  const transformedData = transformKeys(response);

  try {
    const data = DataValidator.validateOrThrow(
      transformedData,
      ResponseAudioFilterOptionsData
    );
    // 手动验证每个动态键对应的数组和数组项
    if (data) {
      for (const [key, items] of Object.entries(data)) {
        if (Array.isArray(items)) {
          for (const item of items) {
            DataValidator.validateOrThrow(item, FilterOptionItem);
          }
        } else {
          throw new Error(`Filter option value for ${key} must be an array`);
        }
      }
    }
    return data;
  } catch (error) {
    console.error(
      "Audio filter options data validation failed:",
      error.message
    );
    throw error;
  }
};

const URL = "/audio/filter-options";

// 获取音频过滤选项
export const audioFilterOptions =
  async (): Promise<ResponseAudioFilterOptionsData> => {
    const response = await api.get<ResponseAudioFilterOptionsResponse>(URL);
    const validatedData = transformAndValidateAudioFilterOptions(response.data);
    return validatedData;
  };
